var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "key",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7387",
    "data-name": "Rectangle 7387",
    width: 35,
    height: 35,
    transform: "translate(0)",
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System"
  }, /*#__PURE__*/React.createElement("g", {
    id: "key_2_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MingCute",
    d: "M35.395,0V35.395H0V0ZM18.573,34.3l-.017,0-.1.052-.028.005h0l-.022-.005-.1-.052a.032.032,0,0,0-.035.008l-.006.016-.025.63.007.03.016.018.153.109.022.006h0l.017-.006L18.6,35l.019-.024h0l.005-.024-.025-.63a.032.032,0,0,0-.024-.027Zm.391-.166-.021,0-.272.136-.015.015h0l0,.017.026.633.007.019h0l.013.01.3.137a.037.037,0,0,0,.042-.012l.006-.021-.05-.907a.037.037,0,0,0-.028-.031Zm-1.055,0a.034.034,0,0,0-.04.008l-.008.021-.05.907a.034.034,0,0,0,.025.035l.023,0,.3-.137.014-.012h0l.006-.017L18.2,34.3l0-.019h0l-.014-.013Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M16.188,7.357a6.636,6.636,0,1,1,2.047,10.781A3.1,3.1,0,0,0,17,17.875H14.992a1.843,1.843,0,0,0-1.843,1.843v2.328H10.821A1.844,1.844,0,0,0,8.977,23.89v2.328H5.67V24.132l7.9-7.9a3.128,3.128,0,0,0,.811-2.848A6.629,6.629,0,0,1,16.188,7.357ZM27.659,5.272a9.587,9.587,0,0,0-16.17,8.7.31.31,0,0,1-.008.174L3.368,22.262a2.212,2.212,0,0,0-.648,1.564v3.851a1.49,1.49,0,0,0,1.489,1.49h5.874a1.844,1.844,0,0,0,1.843-1.843V25h2.328A1.843,1.843,0,0,0,16.1,23.152V20.824H17a.229.229,0,0,1,.061.019,9.587,9.587,0,0,0,10.6-15.572Zm-7.3,7.3a2.212,2.212,0,1,0,0-3.128A2.212,2.212,0,0,0,20.359,12.571Z",
    transform: "translate(1.292 1.17)",
    fill: "#09244b",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.0725c08a4d740658f1653f6241862bb8.svg";
export { ForwardRef as ReactComponent };